import React from 'react'
import { Patient } from '@babylon/consumer-api/types'
import { useFormatMessage, useIntl } from '@babylon/intl'
import formMessages from '@/components/FormRenderer/messages'

interface HelpTextProps {
  patient: Patient
}

const HelpText = ({ patient }: HelpTextProps) => {
  const { formatDate } = useIntl()
  const translate = useFormatMessage()

  return (
    <>
      <div>
        {translate(formMessages.first_name)}: {patient.first_name}
      </div>
      <div>
        {translate(formMessages.last_name)}: {patient.last_name}
      </div>
      <div>
        {translate(formMessages.date_of_birth)}:{' '}
        {/* We have to specify the timezone as the Medkit date component uses always the UTC format */}
        {formatDate(patient.date_of_birth!, { timeZone: 'UTC' })}
      </div>
    </>
  )
}

export default HelpText
